<script>
import { orderBy } from 'lodash'
import { TimesheetPrimaryGroupingType } from '@/shared/constants/timesheet/TimesheetPrimaryGroupingType'
import TimesheetLeafGroupCard from './timesheet-leaf-group-card.vue'

export default {
  name: 'TimeSheetWeekGroup',
  components: { TimesheetLeafGroupCard },
  props: {
    group: {
      type: Object,
      required: true,
    },
    primaryGroupType: {
      type: String,
      default: '',
    },
  },
  computed: {
    orderedTimesheets() {
      if (this.isPrimaryGroupingByClient) {
        return orderBy(
          this.group.timesheets,
          (item) => item[0]?.candidateFullName
        )
      }

      return orderBy(this.group.timesheets, (item) => item[0]?.clientName)
    },
  },
  methods: {
    timesheetsUpdated(selectedTimesheets) {
      this.$emit('timesheetsUpdated', selectedTimesheets)
    },
    changeTime(timesheetData) {
      this.$emit('changeTime', timesheetData)
    },
    isFirstIndex(index) {
      return index === 0
    },
    cancelBookingSubmitted(payload) {
      this.$emit('cancelBookingSubmitted', payload)
    },
    isPrimaryGroupingByClient() {
      return this.primaryGroupType === TimesheetPrimaryGroupingType.client
    },
  },
}
</script>

<template>
  <div class="mb-12">
    <div
      v-for="(leafGroupTimesheets, index) of orderedTimesheets"
      :key="
        `timesheet-leaf-group-card_${group.title}_${leafGroupTimesheets[0].bookingId}`
      "
      class="mb-4"
    >
      <h1 v-if="isFirstIndex(index)" class="subtitle-2 mb-4">
        <v-icon left>mdi-calendar</v-icon> {{ group.title }}
      </h1>

      <TimesheetLeafGroupCard
        :leaf-group-time-sheets="leafGroupTimesheets"
        :primary-group-type="primaryGroupType"
        @timesheetsUpdated="timesheetsUpdated"
        @changeTime="changeTime"
        @cancelBookingSubmitted="cancelBookingSubmitted"
      />
    </div>
  </div>
</template>
